import { Record } from "immutable";

export type ModuleStudiedEventType = {
  sessionId?: string;
  moduleOrder?: number;
  // Zero-indexed number to indicate the position in the session that this module appeared.
  courseId?: string;
  sectionId?: string;
  contentId?: string;
  moduleId?: string;
  moduleType?: string;
  testingActive: boolean;
  content: any;
  // Usually an object - contains the result of module's (randomised) generateContent function
  userAnswer?: any;
  // Usually an object - contains user's input to the module
  score?: number | null;
  moduleScore?: any;
  // Usually an object - contains module-specific feedback on the user's answer
  timeStarted?: string;
  timeFinished?: string;
  gaveUp: boolean;
  submitted: boolean;
  completed: boolean;
};

const defaultValues: ModuleStudiedEventType = {
  sessionId: undefined,
  moduleOrder: undefined,
  courseId: undefined,
  sectionId: undefined,
  contentId: undefined,
  moduleId: undefined,
  moduleType: undefined,
  testingActive: false,
  content: {},
  userAnswer: {},
  score: null,
  moduleScore: {},
  timeStarted: undefined,
  timeFinished: undefined,
  gaveUp: false,
  submitted: false,
  completed: false
};

export default class ModuleStudiedEvent extends Record(defaultValues) {}
